<template>
    <div class="min-w-100">
        <div v-if="files.length > 0">
            <div v-for="file in files" :key="file.id">
                {{ file.filename }}
            </div>
        </div>
        <div v-else>-</div>
    </div>
</template>

<script>
export default {
    name: "file-cell",
    props: {
        cell: {
            type: Object,
            required: true,
        },
        column: {
            type: Object,
            required: true,
        },
    },
    computed: {
        files() {
            let files = this.cell.files;
            return files ?? [];
        },
    },
};
</script>